import { Inject, Injectable } from '@angular/core';
import { HrefResolverService } from '@blk/cwp-ng-framework';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { UrlUtils } from '@ddt-web/url';
import { Observable } from 'rxjs';

import { AuthUtil } from './auth.util';
import { OktaAuthenticationService } from './okta-authentication.service';
import { UserPlatformAuthenticationService } from './user-platform-authentication.service';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationManageService {

	private readonly SIGN_IN_APP_OKTA: string = 'signInAppWithOkta';

	constructor(
		private oktaAuthenticationService: OktaAuthenticationService,
		private userPlatformAuthenticationService: UserPlatformAuthenticationService,
		private hrefResolver: HrefResolverService,
		@Inject('environment') private environment: any
	) { }

	public getUserAuthenticated(): Observable<boolean> {
		const shouldUseOkta = AuthUtil.isOktaEnabled(this.environment.cloud);
		if (shouldUseOkta) {
			return this.oktaAuthenticationService.isUserAuthenticated();
		} else {
			return this.userPlatformAuthenticationService.isUserAuthenticated();
		}
	}

	/**
	 * This function initialize sign in in public app
	 * and takes optional redirect uri and query params which user should come back to on successful login
	 * @param redirectUrl 
	 * @param queryParamsArray 
	 */
	public initializeOktaSignIn(queryParamsObj?: { [key: string]: string }, redirectUrl?: string): void {
		const oktaSignOn: string = this.hrefResolver.getResolvedUrl('okta-sign-on');
		const queryParamString = this.generateQueryParamString(queryParamsObj);
		const redirectPagePath = redirectUrl?.length ? redirectUrl : window.location.pathname;
		const redirectUrlParam: string = encodeURIComponent(redirectPagePath + queryParamString);

		if (oktaSignOn) {
			window.location.href = oktaSignOn + '?redirectUrl=' + redirectUrlParam;
		} else {
			//this is for local dev
			if (UrlUtils.isLocalhost()) {
				sessionStorage.setItem(LocalStorageKey.PublicAppLogin, 'true');
				this.oktaAuthenticationService.loginUser(redirectUrlParam);
			}
		}
	}

	/**
	 * This function generates query param string which can be appended to the redirect url.
	 * @param queryParams
	 * @returns 
	 */
	private generateQueryParamString(queryParams: { [key: string]: string }): string {
		let queryString = window.location.href.indexOf('?') >= 0 ? window.location.href.substring(window.location.href.indexOf('?')) : '';
		if (queryString.search(this.SIGN_IN_APP_OKTA) === -1) {
			queryString += '&signInAppWithOkta=true';
		}
		if (queryParams) {
			queryString += '&' + Object.keys(queryParams).map(key => key + '=' + queryParams[key]).join('&');
		}
		return queryString;
	}
}
